import React, { Fragment, useState } from 'react'
import { formatDbDateWithoutTime } from '../../utils/dateFormater';
import SingleOrderButtons from './SingleOrderButtons';

const SingleReservation = ({ order, user }) => {




    const [copied, setCopied] = useState(false);




    const handleCopy = async (value) => {
        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);

            setTimeout(() => {
                setCopied(false);
            }, 1500);
        } catch (err) {
            console.error("Failed to copy:", err);
        }
    };











    const handleClassName = (orderStatus) => {


        if (orderStatus === "ORDERED") return "text-green-600 bg-green-100";
        if (orderStatus === "REVIEWED") return "text-pink-500 bg-pink-100";
        if (orderStatus === "DELIVERED") return "text-orange-500 bg-orange-100";
        if (orderStatus === "SUSPENDED") return "text-orange-500 bg-orange-100";
        if (orderStatus === "ON_HOLD") return "text-blue-500 bg-blue-100";
        if (orderStatus === "REFUNDED") return "text-green-600 bg-green-100";
        if (orderStatus === "COMMISSIONED") return "text-slate-500 bg-slate-100";
        if (orderStatus === "COMPLETED") return "text-purple-500 bg-purple-100";
        if (orderStatus === "CANCELLED") return "text-[#B04926] bg-[#b0482637]";
        if (orderStatus === "REVIEW_DELETED") return "text-red-500 bg-red-100";
        if (orderStatus === "SYSTEM_CANCELLED") return "text-red-500 bg-red-100";

    }











    return (
        <Fragment>
            <div className={`flex w-[250%] lg:w-full py-[1.2vmax] mt-[1vmax] rounded-xl shadow-2 border-l-[0.2vmax] border-indigo-600 items-center bg-white`}>
                <div className="text-center flex-center items-center flex-[1] min-w-[80px] text-[#4c4c5c] font-bold text-[1.5vmax] lg:text-[0.8vmax]" >
                    #{order?.id}
                </div>
                <div className="px-[0.5vmax] flex-[1] min-w-[100px] text-[#4c4c5c] font-bold text-[1.5vmax] lg:text-[0.8vmax] flex gap-[0.5vmax] items-center " >
                    <span className="text-gray-600">{order?.product_id}</span>
                    <button
                        onClick={() => handleCopy(order?.product_id)}
                        className="text-gray-400 hover:text-indigo-600 transition-colors"
                        title={copied ? "Copied" : "Copy"}
                    >
                        <i className={`fa-regular ${copied ? "fa-circle-check text-green-600" : "fa-copy"} text-[1vmax]`}></i>
                    </button>
                </div>
                {user?.role !== "PMM" &&
                    <div className="flex-center flex-col px-[0.5vmax] flex-[1] min-w-[120px] text-[#4c4c5c] text-[1.5vmax] lg:text-[0.9vmax] " >
                        <div className="font-bold text-gray-700">{order?.pmm_name}</div>
                        <div className="text-gray-500 text-[0.8vmax]">ID: {order?.pmm_id}</div>
                    </div>
                }
                <div className="flex-center font-bold px-[0.5vmax] flex-[1] min-w-[120px] text-gray-700 text-[1.5vmax] lg:text-[0.8vmax] " >
                    {order?.portal_commission_amount ?
                        `Rs. ${Number(order?.pm_commission_amount) + Number(order?.portal_commission_amount)}`
                        :
                        "Rs. 0.00"}
                </div>

                <div className="text-center flex-center px-[0.5vmax] flex-[1.5] min-w-[150px] text-gray-500 font-medium text-[1.5vmax] lg:text-[0.9vmax] " >
                    {formatDbDateWithoutTime(order?.updated_at)}
                </div>

                <div className="flex-center px-[0.5vmax] flex-[1.5] min-w-[130px] " >
                    <span className={`text-[1.3vmax] lg:text-[0.75vmax] font-bold uppercase p-[0.3vmax_0.8vmax] rounded-lg shadow-sm ${handleClassName(order?.status)}`} >
                        {order?.status === "ON_HOLD" ? "ON HOLD" : order?.status === "REVIEW_DELETED" ? "REVIEW DELETED" : order?.status === "SYSTEM_CANCELLED" ? "SYSTEM CANCEL" : order?.status}
                    </span>
                </div>

                <div className="flex-center px-[0.5vmax] flex-[1] min-w-[100px] " >
                    <SingleOrderButtons order={order} user={user} />
                </div>
            </div>
        </Fragment>
    )
}

export default SingleReservation